$(document).ready(function() {
  
  $(".menu-drawer__close-menu-btn").click(function() {
    $("details[open]").removeAttr("open");
    $("summary.header__icon--menu").attr("aria-expanded", false);
  });

  $(document).mouseup(function(e) {
    const drawer = $("#Details-menu-drawer-container");

   if (drawer.hasClass("menu-opening")) {
    setTimeout(function() {
    $("details[open]").removeAttr("open");
    $("summary.header__icon--menu").attr("aria-expanded", false);
    }, 300);
   }
  });
});








